import React, {memo} from "react";

import useCookieConsent from "Hooks/useCookieConsent";

const withCookieConsent = Component => {
	return memo(props => {
		const {cookieConsentRequired, cookieConsentToOptional} = useCookieConsent();
		return <Component
			{...props}
			cookieConsentToOptional={cookieConsentToOptional}
			cookieConsentRequired={cookieConsentRequired} />;
	});
};

export default withCookieConsent;
